// extracted by mini-css-extract-plugin
module.exports = {"optional":"style__optional__KosDS","label":"style__label__sWf-G","tooltip":"style__tooltip__Uh+gH","required":"style__required__pUwB4"};